import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { LoginAdm } from '@/features/login/page/LoginAdm';

export const Route = createFileRoute('/auth/login-adm')({
    component: LoginAdmRoute,
    validateSearch: z.object({
        email: z.string(),
        empresaIdpk: z.coerce.number().optional(),
        redirect: z.string(),
    }),
});

function LoginAdmRoute() {
    const { email, empresaIdpk, redirect } = Route.useSearch();

    return <LoginAdm email={email} empresaIdpk={empresaIdpk} redirect={redirect} />;
}
